import React, { useState, useEffect } from "react";
import { TextField } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { EditCategories } from "src/DAL/AffirmationCategories/Categories/Categories";
import { useSnackbar } from "notistack";
import { s3baseUrl } from "../../../config/config";

export default function EditCategory({ editData, onCloseDrawer, dataList }) {
  const [previews, setPreviews] = useState("");
  const [image, setImage] = React.useState("");
  const [mediaAction, setmediaAction] = useState("update");
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState({
    categoryDescription: "",
    categoryTitle: "",
    categorySlug: "",
  });
  const { enqueueSnackbar } = useSnackbar();

  const handleRemove = () => {
    setPreviews("");
    setImage("");
    setmediaAction("remove");
  };

  const handleUpload = (event) => {
    const fileList = event.target.files;
    setImage(event.target.files[0]);
    const preview = URL.createObjectURL(event.target.files[0]);
    setPreviews(preview);
    setmediaAction("update");
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setState((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  //Adding Category

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const formData = new FormData();
    formData.append("description", state.categoryDescription);
    formData.append("name", state.categoryTitle);
    if (image) {
      formData.append("image", image);
    }
    formData.append("media_action", mediaAction);
    console.log(...formData);
    const result = await EditCategories(state.categorySlug, formData);
    if (result.code === 200) {
      onCloseDrawer();
      dataList();
      setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "success" });
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      ["categoryDescription"]: editData.description,
      ["categoryTitle"]: editData.name,
      ["categorySlug"]: editData.category_slug,
    }));
    if (editData.image) {
      setPreviews(s3baseUrl + editData.image?.thumbnail_1);
    }
  }, [editData]);

  return (
    <div className="container new-memories">
      <form onSubmit={handleSubmit}>
        <TextField
          className="mt-4"
          id="outlined-basic"
          label="Category Title"
          variant="outlined"
          name="categoryTitle"
          value={state.categoryTitle}
          required={true}
          onChange={(e) => handleChange(e)}
        />

        <TextField
          id="outlined-multiline-static"
          label="Category Description"
          multiline
          rows={5}
          variant="outlined"
          style={{ width: "100%" }}
          name="categoryDescription"
          value={state.categoryDescription}
          onChange={(e) => handleChange(e)}
          className="mt-3"
          required={true}
        />
        <p className="mt-2 mb-0">Recommended Size (1000x670)</p>
        <div className="col-md-12 mt-2 d-flex">
          {previews && (
            <span className="preview mt-2">
              <span onClick={handleRemove}>x</span>
              <img src={previews} />
            </span>
          )}
          {previews == "" && (
            <span className="upload-button mt-2">
              <input
                color="primary"
                accept="image/*"
                type="file"
                id="icon-button-file"
                style={{ display: "none" }}
                name="affirmationImage"
                onChange={handleUpload}
              />
              <label htmlFor="icon-button-file">
                <CloudUploadIcon />
              </label>
            </span>
          )}
        </div>
        <div className="text-end mt-3">
          <button className="submit-button" disabled={isLoading}>
            {isLoading ? "Updating..." : "Update"}
          </button>
        </div>
      </form>
    </div>
  );
}
